import React from 'react';

import Slider, { Props as SliderProps } from '@/components/Slider';

import ControlWrapper from './ControlWrapper';
import ValuePreview from './ValuePreview';

export interface Props extends SliderProps {
  id: string;
  label: React.ReactNode;
  secondaryLabel?: string;
  value: number;
  setValue: (value: number) => void;
  definition?: string;
  previewRenderer?: (value: string | number) => React.ReactNode;
  gridArea?: string;
  wrapperStyle?: React.CSSProperties;
  disabled?: boolean;
  onChange?: (value: number) => void;
  handleReset?: () => void;
}

function SliderControl({
  id,
  label,
  secondaryLabel,
  value,
  setValue,
  definition,
  previewRenderer,
  gridArea,
  wrapperStyle,
  disabled,
  onChange,
  handleReset,
  ...delegated
}: Props) {
  return (
    <ControlWrapper
      id={id}
      label={label}
      secondaryLabel={secondaryLabel}
      definition={definition}
      gridArea={gridArea}
      style={wrapperStyle}
      disabled={disabled}
      cornerContents={
        <ValuePreview value={value} renderer={previewRenderer} />
      }
    >
      <Slider
        id={id}
        value={value}
        disabled={disabled}
        onKeyDown={(ev) => {
          if (ev.key === 'Delete' || ev.key === 'Backspace') {
            handleReset?.();
          }
        }}
        {...delegated}
        onChange={(val) => {
          setValue(val);

          if (typeof onChange === 'function') {
            onChange(val);
          }
        }}
      />
    </ControlWrapper>
  );
}

export default SliderControl;
